import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Please provide a first name' },
      ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Please provide a last name' },
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' },
      ]
    },
    eventdate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' },
      ]
    },
    starttime: {
      validations: []
    },
    endtime: {
      validations: []
    },
    plannedguestcount: {
      validations: [
        { type: 'regex', pattern: '^[0-9]*$', message: 'Please provide a guest count in numbers only.'},
      ]
    },
    theme: {
      validations: []
    },
    category: {
      validations: []
    },
    reference: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstname'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:*',
            mapping: 'email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventdate'
          },
          {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Event Start Time:',
        options: [
          { label: '6:00AM'  , value: '06:00:00'},
          { label: '6:30AM'  , value: '06:30:00'},
          { label: '7:00AM'  , value: '07:00:00'},
          { label: '7:30AM'  , value: '07:30:00'},
          { label: '8:00AM'  , value: '08:00:00'},
          { label: '8:30AM'  , value: '08:30:00'},
          { label: '9:00AM'  , value: '09:00:00'},
          { label: '9:30AM'  , value: '09:30:00'},
          { label: '10:00AM' , value: '10:00:00'},
          { label: '10:30AM' , value: '10:30:00'},
          { label: '11:00AM' , value: '11:00:00'},
          { label: '11:30AM' , value: '11:30:00'},
          { label: '12:00PM' , value: '12:00:00'},
          { label: '12:30PM' , value: '12:30:00'},
          { label: '1:00PM'  , value: '13:00:00'},
          { label: '1:30PM'  , value: '13:30:00'},
          { label: '2:00PM'  , value: '14:00:00'},
          { label: '2:30PM'  , value: '14:30:00'},
          { label: '3:00PM'  , value: '15:00:00'},
          { label: '3:30PM'  , value: '15:30:00'},
          { label: '4:00PM'  , value: '16:00:00'},
          { label: '4:30PM'  , value: '16:30:00'},
          { label: '5:00PM'  , value: '17:00:00'},
          { label: '5:30PM'  , value: '17:30:00'},
          { label: '6:00PM'  , value: '18:00:00'},
          { label: '6:30PM'  , value: '18:30:00'},
          { label: '7:00PM'  , value: '19:00:00'},
          { label: '7:30PM'  , value: '19:30:00'},
          { label: '8:00PM'  , value: '20:00:00'},
          { label: '8:30PM'  , value: '20:30:00'},
          { label: '9:00PM'  , value: '21:00:00'},
          { label: '9:30PM'  , value: '21:30:00'},
          { label: '10:00PM' , value: '22:00:00'},
          { label: '11:00 PM', value: '23:00:00' },
          { label: '12:00 AM (next day)', value: '00:00:00' },
        ],
        mapping: 'starttime',
      },
      {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Event End Time:',
        options: [
          { label: '6:00AM'  , value: '06:00:00'},
          { label: '6:30AM'  , value: '06:30:00'},
          { label: '7:00AM'  , value: '07:00:00'},
          { label: '7:30AM'  , value: '07:30:00'},
          { label: '8:00AM'  , value: '08:00:00'},
          { label: '8:30AM'  , value: '08:30:00'},
          { label: '9:00AM'  , value: '09:00:00'},
          { label: '9:30AM'  , value: '09:30:00'},
          { label: '10:00AM' , value: '10:00:00'},
          { label: '10:30AM' , value: '10:30:00'},
          { label: '11:00AM' , value: '11:00:00'},
          { label: '11:30AM' , value: '11:30:00'},
          { label: '12:00PM' , value: '12:00:00'},
          { label: '12:30PM' , value: '12:30:00'},
          { label: '1:00PM'  , value: '13:00:00'},
          { label: '1:30PM'  , value: '13:30:00'},
          { label: '2:00PM'  , value: '14:00:00'},
          { label: '2:30PM'  , value: '14:30:00'},
          { label: '3:00PM'  , value: '15:00:00'},
          { label: '3:30PM'  , value: '15:30:00'},
          { label: '4:00PM'  , value: '16:00:00'},
          { label: '4:30PM'  , value: '16:30:00'},
          { label: '5:00PM'  , value: '17:00:00'},
          { label: '5:30PM'  , value: '17:30:00'},
          { label: '6:00PM'  , value: '18:00:00'},
          { label: '6:30PM'  , value: '18:30:00'},
          { label: '7:00PM'  , value: '19:00:00'},
          { label: '7:30PM'  , value: '19:30:00'},
          { label: '8:00PM'  , value: '20:00:00'},
          { label: '8:30PM'  , value: '20:30:00'},
          { label: '9:00PM'  , value: '21:00:00'},
          { label: '9:30PM'  , value: '21:30:00'},
          { label: '10:00PM' , value: '22:00:00'},
          { label: '11:00 PM', value: '23:00:00' },
          { label: '12:00 AM (next day)', value: '00:00:00' },
        ],
        mapping: 'endtime'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Type of Event:',
                options: [
                  { label: 'Corporate Meeting'  , value: 'Corporate Meeting'},
                  { label: 'Conference'  , value: 'Conference'},
                  { label: 'Exhibitions'  , value: 'Exhibitions'},
                  { label: 'Wedding'  , value: 'Wedding'},
                  { label: 'Social'  , value: 'Social'},
                  { label: 'Other'  , value: 'Other'},                  
                ],
                mapping: 'theme'
              },
              {
              type: 'multiple-choice',
              size: 'Medium',
              label: 'Group Setting:',
              options: [
                { label: 'Tenant', value: 'Tenant' },
                { label: 'Social', value: 'Social' },
                { label: 'Corporate', value: 'Corporate' },
                { label: 'Non-Profit', value: 'Non-Profit' },
                { label: 'Other', value: 'Other' },
              ],
              mapping: 'category'
            },
            {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?:',
            options:[
              { label: 'Google'  , value: 'Google'},
              { label: 'Social Media Platform'  , value: 'Social Media Platform'},
              { label: 'Referral'  , value: 'Referral'},
              { label: 'Other'  , value: 'Other'},
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Send Request'
          }
        ]
      }
    ]
  },
  info: {
    title: 'CP Group Contact Form',
    formId: '2177',
    clientKey: 'C4B6AFF1-E8A5-46AD-AA4D-D12C3EB74925',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    redirectUrl: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
